import { render, staticRenderFns } from "./SelectAudience.vue?vue&type=template&id=ea63e306&scoped=true&"
import script from "./SelectAudience.vue?vue&type=script&lang=js&"
export * from "./SelectAudience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea63e306",
  null
  
)

export default component.exports